import { render, staticRenderFns } from "./RiskmatrixChartByCategory.vue?vue&type=template&id=2ec5af78&scoped=true"
import script from "./RiskmatrixChartByCategory.vue?vue&type=script&lang=js"
export * from "./RiskmatrixChartByCategory.vue?vue&type=script&lang=js"
import style0 from "./RiskmatrixChartByCategory.vue?vue&type=style&index=0&id=2ec5af78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5af78",
  null
  
)

export default component.exports